<script setup lang="ts">
import VerticalSlideTransition from '@/shared/components/transition/VerticalSlideTransition.vue'
import SkeletonLoader from '@/shared/components/loader/SkeletonLoader.vue'

interface Props {
  open: boolean
  loading?: boolean
}

defineProps<Props>()
</script>

<template>
  <VerticalSlideTransition>
    <div
      v-if="open"
      class="z-40 absolute mt-1 border border-gray-300 bg-white dark:border-gray-800 dark:bg-black w-full overflow-x-hidden max-h-64 focus:outline-none shadow-md"
    >
      <ul v-if="loading">
        <li class="p-2">
          <SkeletonLoader class="w-8/9 h-5" />
        </li>
        <li class="p-2">
          <SkeletonLoader class="w-1/2 h-5" />
        </li>
        <li class="p-2">
          <SkeletonLoader class="w-3/4 h-5" />
        </li>
      </ul>
      <ul>
        <slot></slot>
      </ul>
    </div>
  </VerticalSlideTransition>
</template>
